module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_plan_show_bg_05-a6f7bc3fe9902bae6e22d06b91ebbce7.png";